import React, { Component } from 'react';
import { connect } from 'react-redux';

/**
 * @package VirtuOwl
 * @type {React.ComponentClass}
 */
class ActiveVisitScreenshot extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div id="screenshot" className="dialog-box" title="Take Screenshot">
                <img src="images/screenshot/001.jpg" alt="" />
                <hr />
                <button className="mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect mdl-button--colored mdl-button--mini-fab">
                    <i className="material-icons">edit</i>
                </button>
                <button className="mdl-button blue-bg mdl-js-button mdl-button--raised mdl-js-ripple-effect">
                    Finish
                </button>
            </div>
        );
    }
}

export default connect()(ActiveVisitScreenshot);
